import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';

@Component({
    selector: 'app-staff-attendance-summary',
    templateUrl: './staff-attendance-summary.component.html',
    styleUrls: ['./staff-attendance-summary.component.css']
})
export class StaffAttendanceSummaryComponent implements OnInit {
    Submitted: boolean = false;
    StaffMonthlyAttendanceList = [];
    CurrentStatusHeader = [];
    StaffList = [];
    EmployeeCategoryList = [];
    LeaveTypeList = [];
    DayList = [];
    MonthlyAttendance = [];
    constructor(private payrollService: HrService, private lookupservice: LookupService, public globalHelper: GlobalHelper,
        private spinnerService: Ng4LoadingSpinnerService) { }

    StaffMonthlyAttendanceModel = {
        MonthID: 0,
        EmployeeCategoryID: 0,
        PrimaryDepartmentID: 0,
        DesignationID: 0,
        StaffID:0,
       
    }
    ClearSearch() {
        this.StaffMonthlyAttendanceModel.MonthID =0;
        this.StaffMonthlyAttendanceModel.EmployeeCategoryID = 0;
        this.StaffMonthlyAttendanceModel.PrimaryDepartmentID = 0;
        this.StaffMonthlyAttendanceModel.DesignationID = 0;
        this.StaffMonthlyAttendanceModel.StaffID = 0;
        this.StaffMonthlyAttendanceList = [];
        this.Submitted=false;

    }


    FieldValidation() {

        return this.StaffMonthlyAttendanceModel.MonthID == 0;
    }


    ClearList(){
        this.StaffMonthlyAttendanceList=[];
      }
    GetStaffMonthlyAttendanceSummary() {
        this.Submitted = true;
        if (!this.FieldValidation()) {
            this.Submitted = false;
            this.spinnerService.show();
            this.payrollService.GetStaffMonthlyAttendanceSummary(JSON.stringify(this.StaffMonthlyAttendanceModel)).subscribe((data: any) => {
                this.StaffMonthlyAttendanceList = data.StaffMonthlyAttendanceList;
                if (this.StaffMonthlyAttendanceList != null && this.StaffMonthlyAttendanceList.length > 0)
                    this.MonthlyAttendance = this.StaffMonthlyAttendanceList[0].DayList;
                this.CurrentStatusHeader = data.CurrentStatusHeader;

                this.spinnerService.hide();

            });
        }
    };

    ValidateVerify() {

        var flag = true;

        for (var i = 0; i < this.StaffMonthlyAttendanceList.length; i++) {
   
           
            if (this.StaffMonthlyAttendanceList[i].IsLocked) {

                var StaffDailyStatusList = this.StaffMonthlyAttendanceList[i].StaffDailyStatusList;
                var count = 0;
                for (var j = 0; j < StaffDailyStatusList.length; j++)
                    count = count + StaffDailyStatusList[j].Count;
               
                if (this.StaffMonthlyAttendanceList[i].DayList.length > count) {
                    flag = false;
                    alert('Please make sure all selected condidate attendance verified.');
                    break;
                }
            }

        }

        return flag;
    }

    SaveStaffMonthlyAttendance() {

        if (this.ValidateVerify()) {
            var AttendanceList = [];
            var Attendance = this.StaffMonthlyAttendanceList;
            for (var i = 0; i < Attendance.length; i++) {
                AttendanceList.push(Attendance[i]);
            }
            this.spinnerService.show();

            this.payrollService.SaveStaffMonthlyAttendance(JSON.stringify(AttendanceList), JSON.stringify(this.StaffMonthlyAttendanceModel)).subscribe((data: any) => {
                this.globalHelper.CheckActionStatus(data);

                this.spinnerService.hide();
                if (data.webResponse.Status)
                    this.GetStaffMonthlyAttendanceSummary();

            });
        }

    };



    EmployeeList = [];
    GetEmployee() {
        this.ClearList();
        this.StaffMonthlyAttendanceModel.StaffID = 0;
       
        this.lookupservice.GetLookupsList('EmployeeCode', '').subscribe((data: any) => {
            this.EmployeeList = data.LookupItems;
        });
    };

    SalaryMonthList = [];
    GetSalaryMonth() {
        this.lookupservice.GetLookupsList('SalaryMonth', '').subscribe((data: any) => {
            this.SalaryMonthList = data.LookupItems;
        });
    };

    GetEmployeeCategory() {
        this.lookupservice.GetLookupsList('EmployeeCategory', '').subscribe((data: any) => {
            this.EmployeeCategoryList = data.LookupItems;
        });
    };

    ListDepartment = []
    GetDepartment() {
        this.lookupservice.GetLookupsList('Department', '').subscribe((data: any) => {
            this.ListDepartment = data.LookupItems;
        });

    }

    DesignationList = []
    GetDesignation() {
        this.lookupservice.GetLookupsList('Designation', '').subscribe((data: any) => {
            this.DesignationList = data.LookupItems;
        });
    };
    GetLeaveType() {

        this.lookupservice.GetLookupsList('LeaveType', '').subscribe((data: any) => {
            this.LeaveTypeList = data.LookupItems;
            this.LeaveTypeList.splice(0, 1);
        });
    };
    YearList = [];

    ngOnInit() {
        this.GetDesignation();
        this.GetDepartment();
        this.GetLeaveType();
        this.GetEmployeeCategory();
        this.GetSalaryMonth();
        this.GetEmployee();

    }
}